import apis from "../../core/apis.js";

class DispatcherResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.dispatcher).get(options);
  }

  get(id) {
    return this.$resource(apis.dispatcher + id).get();
  }

  getSuccessful(params, name, id) {
    return this.$resource(apis.dispatcher + id + "/successful_rides").get(
      params
    );
  }

  getSkipped(params, name, id) {
    return this.$resource(apis.dispatcher + id + "/skipped_rides").get(params);
  }

  getFailed(params, name, id) {
    return this.$resource(apis.dispatcher + id + "/failed_schedules").get(
      params
    );
  }

  getInQueue(params, _name, id) {
    return this.$resource(apis.dispatcher + id + "/inqueue_schedules").get(
      params
    );
  }

  getLogs(params, _name, id) {
    return this.$resource(apis.dispatcher + id + "/logs").get(params);
  }

  search(search = "") {
    return this.$resource(apis.dispatcher).get({ search });
  }
}

export default DispatcherResource;



// WEBPACK FOOTER //
// ./src/resources/dispatcher/dispatcher.resource.js